import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'
import { NAMESPACE } from 'locale'
import { emarV2Constants } from 'locale/emarV2'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'
import type { EmarSecondSignatureSettings } from './types'
import { EMAR_SECOND_SIGNATURE_QUERY_KEY } from './useEmarSecondSignatureSettings'

const useUpdateEmarSecondSignatureSettings = () => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)
  const queryClient = useQueryClient()

  const { mutate: updateSecondSignatureSettings, isLoading } = useMutation<
    EmarSecondSignatureSettings,
    unknown,
    EmarSecondSignatureSettings,
    void
  >(
    (json: EmarSecondSignatureSettings) =>
      postJSON({
        method: 'PUT',
        url: '/emar-settings/second-signature',
        json
      }),
    {
      onSuccess: (response) => {
        // Response echoes back what was saved, so use it instead of re-fetching.
        queryClient.setQueryData(EMAR_SECOND_SIGNATURE_QUERY_KEY, response)
        showToast({ title: t(emarV2Constants.SECOND_SIGNATURE_SAVED_TOAST) })
      },
      onError: () => {
        showToast({
          title: t(emarV2Constants.SECOND_SIGNATURE_SAVE_ERROR),
          type: 'error'
        })
      }
    }
  )

  return { updateSecondSignatureSettings, isLoading }
}

export default useUpdateEmarSecondSignatureSettings
